import React from "react";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation("footer");

  return (
    <>
      {/* FOOTER */}
      <footer className="bg-white border-t border-gray-200 pt-10 pb-4">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">

          {/* Brand Info */}
          <div className="flex flex-col items-center md:items-start">
            <img
              src="/img/logos/logo1.png"
              alt={t("logoAlt")}
              className="h-52 w-52 mb-2 object-contain"
            />
          </div>

          {/* Essential Links */}
          <div className="text-center md:text-left mt-6">
            <h4 className="font-bold text-gray-800 mb-4 text-sm uppercase tracking-wider">
              {t("essentialLinks")}
            </h4>

            <ul className="space-y-2 text-xs text-gray-500">
              <li>
                <a href="#" className="hover:underline">
                  {t("helpFaqs")}
                </a>
              </li>

              <li>
                <a href="#" className="hover:underline">
                  {t("termsOfService")}
                </a>
              </li>

              <li>
                <a href="#" className="hover:underline">
                  {t("privacyPolicy")}
                </a>
              </li>
            </ul>
          </div>

          {/* Support & Contact */}
          <div className="text-center md:text-left mt-6">
            <h4 className="font-bold text-gray-800 mb-4 text-sm uppercase tracking-wider">
              {t("supportContact")}
            </h4>

            <ul className="space-y-2 text-xs text-gray-500">
              <li>
                <a href="#" className="hover:underline">
                  {t("contactSupport")}
                </a>
              </li>

              <li>
                <a href="#" className="hover:underline">
                  {t("reportIssue")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-100 pt-2">
          <div className="max-w-6xl mx-auto px-6 text-left">
            <span className="text-[12px] text-gray-600 pl-10">
              {t("copyright")}
            </span>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;